<div [ngClass]="{overlay: $showDetails()}" (click)="closeDetails()"></div>
<div class="card">
  <div class="card-header">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <i class="ic-alert-triangle ic-md icon"></i>
        <div class="d-flex flex-column ml-3">
          <div class="alerts-title">Alerts</div>
          <div class="alerts-subtitle">{{pageTitle}}</div>
        </div>
      </div>

      <div class="button-container">
        <app-button
          [text]="'Mark All as Read'"
          [iconClass]="'icon ic-circle-check'"
          (clickBtn)="markAllRead()"
        ></app-button>

        @if (checkedInboxAlerts.length) {
          <div ngbDropdown [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']" class="dropdown">
            <app-button
              ngbDropdownToggle
              id="bulk-actions-dd"
              [text]="'Actions'"
              [iconLast]="true"
              [iconClass]="'icon ic-xs ic-select-icon'"
            ></app-button>
            <div ngbDropdownMenu aria-labelledby="bulk-actions-dd" class="dropdown-menu dropdown-menu-right">
              <div class="dropdown-item" (click)="bulkMarkRead()">
                <a class="dropdown-button">
                  <i class="icon ic-circle-check"></i>
                  <span>Mark as Read</span>
                </a>
              </div>
              <div class="dropdown-item" (click)="bulkArchive()">
                <a class="dropdown-button">
                  <i class="icon ic-archive"></i>
                  <span>Archive</span>
                </a>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <app-grid
    [colDefs]="$any(colDefs)"
    [rowData]="[]"
    [totalRows]="totalRows"
    [maxBlocksInCache]="maxBlocksInCache"
    [gridOptions]="gridOptions"
    [pageTitle]="pageTitle"
    [suppressRowClickSelection]="true"
    [rowModelType]="serverRowModelType"
    [serverSideDatasource]="dataSource"
    [getRowId]="getRowId"
    [pagination]="true"
    [paginationPageSize]="defaultPageSize"
    [cacheBlockSize]="cacheBlockSize"
    (gridReady)="onGridReady($event)"
    (itemSelect)="selectInboxAlerts($event)"
    (search)="onSearch($event)"
  ></app-grid>
</div>

<div class="alert-details" [@expandDetail]="$showDetails() ? 'alert-expanded' : 'alert-collapsed'">
  <div class="alert-details-header d-flex align-items-center">
    <div class="close-icon-container d-flex justify-content-center align-items-center">
      <span class="icon ic ic-close cursor-pointer" (click)="closeDetails()"></span>
    </div>
    <div class="info-container">
      <div class="header-title">{{$selectedAlert()?.model?.title}}</div>
      <div class="alert-pagination-container">
        <div class="pages">{{currentAlertIndex + 1}} of {{totalRows}}</div>
        <div class="arrow-btn-container">
          <i
            class="icon ic-arrow-left"
            [ngClass]="{'disabled': !currentAlertIndex}"
            (click)="previousAlert()"
          ></i>
          <i
            class="icon ic-arrow-right"
            [ngClass]="{'disabled': currentAlertIndex + 1 === totalRows}"
            (click)="nextAlert()"
          ></i>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="alert-details-content" [@expandDetail]="$showDetails() ? 'alert-expanded' : 'alert-collapsed'">
  <app-alert-details
    [alert]="$selectedAlert()!"
    (updateAlert)="updateAlertGridRow($event)"
  ></app-alert-details>
</div>
